import type { SupplierKind } from "../types";

export const supplierBasicDefaultListParams = {
  page: 1,
  pageSize: 20,
} as const;

export const supplierBasicPageSizeOptions = [10, 20, 50];

export const supplierAttachmentDefaultType = "qualification_cert";

export const supplierContactRoleOptions = [
  { label: "运营", value: "operation" },
  { label: "报价", value: "quote" },
  { label: "结算", value: "settlement" },
  { label: "紧急", value: "emergency" },
  { label: "其他", value: "other" },
] as const;

export const supplierAttachmentTypeOptions = [
  { label: "资质证书", value: "qualification_cert" },
  { label: "营业执照", value: "business_license" },
  { label: "其他附件", value: "other_attachment" },
] as const;

export const supplierTimedCooperationStatusOptions = [
  { label: "候选", value: "candidate" },
  { label: "洽谈中", value: "negotiating" },
  { label: "已核验", value: "verified" },
  { label: "合作中", value: "active" },
  { label: "已暂停", value: "paused" },
  { label: "已终止", value: "terminated" },
] as const;

export const supplierTimedReviewStatusOptions = [
  { label: "待审核", value: "pending" },
  { label: "已通过", value: "approved" },
  { label: "已拒绝", value: "rejected" },
] as const;

export const supplierBasicPermissions = {
  access: "supply.basic_settings:access",
  manage: "supply.basic_settings:manage",
  manageContact: "supply.basic_settings:manage_contact",
  manageAccount: "supply.basic_settings:manage_account",
  manageAttachment: "supply.basic_settings:manage_attachment",
  manageCapability: "supply.basic_settings:manage_capability",
} as const;

export const supplierBasicStatusOptions = [
  { label: "全部状态", value: "" },
  { label: "启用", value: "false" },
  { label: "停用", value: "true" },
];

export const supplierSubjectNatureOptions = [
  { label: "全部主体性质", value: "" },
  { label: "组织", value: "organization" },
  { label: "个人", value: "individual" },
  { label: "内部主体", value: "internal" },
  { label: "未知", value: "unknown" },
] as const;

export const supplierCooperationStatusOptions = [
  { label: "全部合作状态", value: "" },
  { label: "潜在", value: "potential" },
  { label: "启用", value: "enabled" },
  { label: "暂停", value: "paused" },
  { label: "停用", value: "disabled" },
  { label: "终止", value: "stopped" },
] as const;

export const supplierEligibilityOptions = [
  { label: "全部", value: "" },
  { label: "具备", value: "true" },
  { label: "不具备", value: "false" },
] as const;

export type SupplierKindMeta = {
  kind: SupplierKind;
  title: string;
  createLabel: string;
  apiSegment: string;
  showParentGround: boolean;
  showHousLevel: boolean;
  showUserOptions: boolean;
};

export const supplierKindMeta: Record<SupplierKind, SupplierKindMeta> = {
  guides: {
    kind: "guides",
    title: "导游",
    createLabel: "新增导游",
    apiSegment: "guides",
    showParentGround: true,
    showHousLevel: false,
    showUserOptions: true,
  },
  buses: {
    kind: "buses",
    title: "车队",
    createLabel: "新增车队",
    apiSegment: "buses",
    showParentGround: true,
    showHousLevel: false,
    showUserOptions: false,
  },
  hotels: {
    kind: "hotels",
    title: "酒店供应商（主体）",
    createLabel: "新增酒店供应商",
    apiSegment: "hotels",
    showParentGround: true,
    showHousLevel: false,
    showUserOptions: false,
  },
  restaurants: {
    kind: "restaurants",
    title: "餐厅供应商",
    createLabel: "新增餐厅供应商",
    apiSegment: "restaurants",
    showParentGround: true,
    showHousLevel: false,
    showUserOptions: false,
  },
  grounds: {
    kind: "grounds",
    title: "地接",
    createLabel: "新增地接",
    apiSegment: "grounds",
    showParentGround: false,
    showHousLevel: false,
    showUserOptions: false,
  },
};
